export const defaultExceptionType = 'Error';
